export const SIDEMENU_UPDATE_TEXT_SEARCH =
  "sidemenu/SIDEMENU_UPDATE_TEXT_SEARCH"

export const SIDEMENU_UPDATE_MODE_SEARCH =
  "sidemenu/SIDEMENU_UPDATE_MODE_SEARCH"
